import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const Background = () => {
    const mx = useMotionValue(0.5);
    const my = useMotionValue(0.5);
    const sx = useSpring(mx, { stiffness: 38, damping: 22, mass: 0.8 });
    const sy = useSpring(my, { stiffness: 38, damping: 22, mass: 0.8 });
    const x = useTransform(sx, [0, 1], [16, -16]);
    const y = useTransform(sy, [0, 1], [10, -10]);

    useEffect(() => {
        const onMove = (e) => {
            mx.set(e.clientX / window.innerWidth);
            my.set(e.clientY / window.innerHeight);
        };
        window.addEventListener("pointermove", onMove);
        return () => window.removeEventListener("pointermove", onMove);
    }, [mx, my]);

    return (
        <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
            <motion.img
                src="/bg-aurora.webp"
                alt=""
                style={{ x, y }}
                initial={{ opacity: 0, scale: 1.12 }}
                animate={{ opacity: 1, scale: 1.07 }}
                transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
                className="absolute inset-0 h-full w-full object-cover"
                draggable="false"
                fetchPriority="high"
                decoding="async"
                width="1672"
                height="941"
                data-testid="aurora-background"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#060A12]/75 via-[#060A12]/25 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#060A12]/60 via-transparent to-[#060A12]/70" />
        </div>
    );
};

export default Background;
